import { getSlugFromHostname } from '@/api/client';

/**
 * 申込フォームの公開 URL を組み立てる。
 * 優先順: customDomain > slug.jiayin.jp > 現ホスト/tenant/apply
 *
 * - 申込フォームは tenant アプリに配置されているため、Vite の base `/tenant/` を含む必要がある
 * - estate.jiayin.jp から管理画面で操作している場合、window.location.origin だと
 *   `https://estate.jiayin.jp/apply/...` になってしまい ApplyForm に到達しないので、
 *   必ずテナントサブドメインまたはカスタムドメインに向けること
 */
export function buildApplyUrl(
  token: string,
  opts?: { slug?: string | null; customDomain?: string | null }
): string {
  const customDomain = opts?.customDomain?.trim();
  if (customDomain) return `https://${customDomain}/tenant/apply/${token}`;

  const slug = opts?.slug ?? getSlugFromHostname();
  if (slug) return `https://${slug}.jiayin.jp/tenant/apply/${token}`;

  return `${window.location.origin}/tenant/apply/${token}`;
}
